import sanity from "/lib/sanity/client";

import Seo from "utils/seo";

import Footer from "components/Footer";
import CmsBlock from "components/CmsBlock";
import { Block, Section } from "/components/Layout";
import HeaderMedia from "/components/HeaderMedia";
import PortableText from "/components/cms/portableText";

type ServiceProps = {
  page: {
    title: string;
    intro: { richText: any };
    content: any;
    headerMedia: any;
    slug: string;
  };
};

const Service = ({ page }: ServiceProps) => {
  const { title, intro, content = [], headerMedia = [] } = page || {};

  return (
    <>
      <Seo page={page} isFrontpage />

      <article>
        <Section limitedWidth outer="firstSection">
          {title && (
            <Block bottom={7} mobileTop={4}>
              <h1>{title}</h1>
            </Block>
          )}
          {intro && <PortableText blocks={intro.richText} />}
        </Section>

        {!!headerMedia?.length && <HeaderMedia data={headerMedia} />}

        {content?.map((item: { _key: string }) => (
          <CmsBlock data={item} key={item._key} />
        ))}
      </article>

      <Footer />
    </>
  );
};

// Get data for this particular page based on slug

const query = `*[_type == "page" && slug.current == "service"]{
	title,
  intro,
  content[]{
    ...,
    "faq": title, faq[]->{_id, title, richText, "category": category[]->{title}},
    "image": image{..., asset->{_id, metadata{dimensions, lqip}}},   
  },
  headerMedia,
  seo
}[0]`;

export const getStaticProps = async () => {
  const page = await sanity.fetch(query);
  return {
    props: {
      page
    }
  };
};

export default Service;
